import { npSectionMtClassName } from "src/components/np-design/components/constants"
import { HeroSection } from "./HeroSection"
import { useProductContext } from "./context"

export type ProductHeroSectionProps = {
  offset: number
  count?: number
}

export const ProductHeroSectionRange = ({ offset, count }: ProductHeroSectionProps) => {
  const { heroSections } = useProductContext()

  const range = count ? heroSections?.slice(offset, offset + count) : heroSections?.slice(offset)

  if (!range?.length) {
    return null
  }

  return (
    <div className={npSectionMtClassName}>
      {range.map((heroSection, index) => (
        <HeroSection key={index} {...heroSection} />
      ))}
    </div>
  )
}
